const labels = {
    TITLE: "QC Automated Document Delivery System",
    SEARCH_TITLE: "Delivery Track & Trace",
    BTN_LABEL: "Track",
    IN_TRANSIT: "IN_TRANSIT",
    BEING_DELIVERED: "Being Delivered",
    EMPTY_STATE: "Cannot be empty state",
    TRACK_NO: "trackNo",
    VIEW_TRACKING_PAGE: "Document delivery tracking page"
}

export default labels;